import { cmsBaseUrl } from '../client'

export function toCmsMediaFileUrl(imagePath: string | undefined | null): string | null {
  if (!imagePath) {
    return null
  }
  const baseUrl = cmsBaseUrl()
  return `${baseUrl}${imagePath}`
}
